export const CLICK_INSURANCE_SLIDEOUT_BUTTON = 'CLICK_INSURANCE_SLIDEOUT_BUTTON';
export const VIEW_INSURANCE_SLIDEOUT = 'VIEW_INSURANCE_SLIDEOUT';
export const CLOSE_INSURANCE_SLIDEOUT = 'CLOSE_INSURANCE_SLIDEOUT';
export const SELECT_INSURANCE_PROVIDER_NAME = 'SELECT_INSURANCE_PROVIDER_NAME';
export const SEARCH_INSURANCE_PROVIDER_NAME = 'SEARCH_INSURANCE_PROVIDER_NAME';
export const AUTOCOMPLETE_INSURANCE_PROVIDER_NAME = 'AUTOCOMPLETE_INSURANCE_PROVIDER_NAME';
export const SAVE_INSURANCE_PROVIDER = 'SAVE_INSURANCE_PROVIDER';
export const CANCEL_INSURANCE_PROVIDER = 'CANCEL_INSURANCE_PROVIDER';
